import { render, staticRenderFns } from "./SSSalonDashboardView.vue?vue&type=template&id=56872554&scoped=true&"
import script from "./SSSalonDashboardView.vue?vue&type=script&lang=js&"
export * from "./SSSalonDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./SSSalonDashboardView.vue?vue&type=style&index=0&id=56872554&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56872554",
  null
  
)

export default component.exports